'use strict';

var tslib_es6 = require('./tslib.es6-130a177d.js');
var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var CloseIcon = styled__default['default'].div.withConfig({ displayName: "ww-uikit_CloseIcon_lb1ysepl", componentId: "sc-3dmjiw" })(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    position: relative;\n    display: inline-block;\n    width: ", ";\n    height: ", ";\n\n    &::before,\n    &::after {\n        position: absolute;\n        top: 0;\n        left: 50%;\n        content: '';\n        height: 100%;\n        border-left: 1px solid;\n    }\n\n    &::before {\n        transform: rotate(45deg);\n    }\n\n    &::after {\n        transform: rotate(-45deg);\n    }\n"], ["\n    position: relative;\n    display: inline-block;\n    width: ", ";\n    height: ", ";\n\n    &::before,\n    &::after {\n        position: absolute;\n        top: 0;\n        left: 50%;\n        content: '';\n        height: 100%;\n        border-left: 1px solid;\n    }\n\n    &::before {\n        transform: rotate(45deg);\n    }\n\n    &::after {\n        transform: rotate(-45deg);\n    }\n"])), function (_a) {
    var size = _a.size;
    return size || '10px';
}, function (_a) {
    var size = _a.size;
    return size || '10px';
});
var templateObject_1;

exports.CloseIcon = CloseIcon;
//# sourceMappingURL=CloseIcon-e9513739.js.map
